import { defineMessages } from 'react-intl';

export const analysisMessages = defineMessages({
  changeAnalysisModeSuccess: {
    id: 'widgets.identity.analysis_configuration.change_analysis_mode_success',
    defaultMessage: 'The analysis configuration has been successfully modified.',
    description: 'notification text when the editing of the analysis configuration is successful.',
  },
  changeAnalysisModeError: {
    id: 'widgets.identity.analysis_configuration.change_analysis_mode_error',
    defaultMessage: 'An error occurred while changing the configuration of the analysis.',
    description: 'notification text when the editing of the analysis configuration is unsuccessful.',
  },
  refreshAnalysisSuccess: {
    id: 'widgets.identity.analysis_configuration.refresh_analysis_success',
    defaultMessage: 'Recovery of the new data has been successfully completed.',
    description: 'notification text when the retrieving of the new data is successful.',
  },
  refreshAnalysisError: {
    id: 'widgets.identity.analysis_configuration.refresh_analysis_error',
    defaultMessage: 'An error occurred while retrieving the new data.',
    description: 'notification text when the retrieving of the new data is unsuccessful.',
  },
});
